var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDots = function SvgDots(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 269.9 269.9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M269.9,139.45c-.72.33-.65,1.1-.91,1.67a8.36,8.36,0,0,1-16.08-3.51,8.39,8.39,0,0,1,7.25-8,8.51,8.51,0,0,1,9.1,5.82c.18.51-.07,1.22.64,1.5Z",
    fill: "#6e9964"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.45,269.9c-.2-.71-.91-.63-1.41-.84a8.35,8.35,0,1,1,11.25-8.88,8.49,8.49,0,0,1-5.85,9.08c-.51.18-1.23-.1-1.49.64Z",
    fill: "#16739d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.45,0c.24.75,1,.75,1.56,1.06a8.41,8.41,0,0,1-4,15.76,8.54,8.54,0,0,1-8.08-6.2,8.39,8.39,0,0,1,3.79-9.43c.6-.37,1.47-.36,1.76-1.19Z",
    fill: "#44bfb7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0,136c1.1-2,2.06-4.1,4.24-5.31a8.28,8.28,0,0,1,11.3,3,8.21,8.21,0,0,1-2.79,11.48,8.1,8.1,0,0,1-11.34-2.55C.89,141.7.47,140.81,0,140Z",
    fill: "#fcd472"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.14,188.08a8.39,8.39,0,0,1-.07,16.77,8.39,8.39,0,1,1,.07-16.77Z",
    fill: "#4f264b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.09,81.51a8.33,8.33,0,1,1,8.33-8.45A8.4,8.4,0,0,1,23.09,81.51Z",
    fill: "#059d4d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M254.94,196.6a8.34,8.34,0,0,1-16.68-.15,8.43,8.43,0,0,1,8.44-8.4A8.32,8.32,0,0,1,254.94,196.6Z",
    fill: "#785aa6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M196.58,238.27a8.34,8.34,0,1,1-8.52,8.31A8.41,8.41,0,0,1,196.58,238.27Z",
    fill: "#04a3de"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M196.64,35.52A8.34,8.34,0,0,1,188,27.37,8.43,8.43,0,0,1,204.89,27,8.31,8.31,0,0,1,196.64,35.52Z",
    fill: "#d368a0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.51,246.62a8.32,8.32,0,1,1-8.37-8.32A8.23,8.23,0,0,1,81.51,246.62Z",
    fill: "#035ea6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5,27.24a8.14,8.14,0,0,1-8.41,8.28,8.34,8.34,0,1,1,8.41-8.28Z",
    fill: "#f27658"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M246.69,81.5a8.11,8.11,0,0,1-8.34-8.32,8.29,8.29,0,0,1,16.58-.11A8.11,8.11,0,0,1,246.69,81.5Z",
    fill: "#faac65"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDots, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dots.3354aeca.svg";
export { ForwardRef as ReactComponent };